import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const savedUser = localStorage.getItem('portfolio_user');
      const savedToken = localStorage.getItem('portfolio_token');
      if (savedUser && savedToken) {
        const parsedUser = JSON.parse(savedUser);
        setUser(parsedUser);
      }
    } catch (error) {
      console.error('Error parsing saved user data:', error);
      // Clear corrupted data
      localStorage.removeItem('portfolio_user');
      localStorage.removeItem('portfolio_token');
    } finally {
      setLoading(false);
    }
  }, []);

  const login = async (username, password) => {
    try {
      const response = await authApi.login(username, password);
      if (response.success && response.user && response.token) {
        setUser(response.user);
        localStorage.setItem('portfolio_user', JSON.stringify(response.user));
        localStorage.setItem('portfolio_token', response.token);
        return { success: true };
      }
      return { success: false, error: response.error || 'Invalid credentials' };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: error.message || 'Login failed. Please check if the backend is running.' };
    }
  };

  const register = async (username, password) => {
    try {
      const response = await authApi.register(username, password);
      if (response.success && response.user && response.token) {
        setUser(response.user);
        localStorage.setItem('portfolio_user', JSON.stringify(response.user));
        localStorage.setItem('portfolio_token', response.token);
        return { success: true };
      }
      return { success: false, error: response.error || 'Registration failed' };
    } catch (error) {
      console.error('Registration error:', error);
      return { success: false, error: error.message || 'Registration failed. Please check if the backend is running.' };
    }
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('portfolio_user');
    localStorage.removeItem('portfolio_token');
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
